import styled from 'styled-components';
import theme from '../../../../theme';
/**
 * @class
 * Represents labels inside the application.
 *
 * @component
 * @example
 * return (
 * <WrapperBox border>
 *   <Label>Some Label:</Label>
 *   <p>Text below the label</p>
 * </WrapperBox>
 * )
 */
const Label = styled.label.attrs({
  className: 'label',
})`
  &&& {
    display: block;
    text-transform: uppercase;
    font-size: ${theme.fonts.min};
    color: ${theme.colors.lightText};
    font-weight: normal;
    margin: 0 0 8px 0;
    letter-spacing: 0.1em;
  }
`;

export default Label;
